import { Bound } from "lib/@components/binding/Bound"
import { Button, Grid, ListItem } from "@mui/material"
import { BoundTextField, BoundTypography } from "lib/@components/binding/bound-components"
import { raise } from "library/local-events/index.mjs"
import { useState } from "react"
import { TaskEditor } from "slot-definitions"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function raiseTask(task) {
    raise(task.event, task.params)
}

export function Task({ last }) {
    const { target } = useBoundContext()
    const [isValid, setIsValid] = useState(true)
    const [workingValue, setWorkingValue] = useState(null)
    return (
        <ListItem divider={!last} data-cy="server-task-item">
            <Bound onChange={isUpdated}>
                <Grid container spacing={1} alignItems="center">
                    <Grid item xs={5} sx={{ textAlign: "left" }}>
                        <BoundTypography field="name" />
                    </Grid>
                    <Grid item xs={5}>
                        <TaskEditor.Slot type={target.event}>
                            <BoundTextField
                                fullWidth
                                field="params"
                                transformIn={stringifyData}
                                transformOut={checkValid}
                            />
                            {!isValid && <>Invalid JSON</>}
                        </TaskEditor.Slot>
                    </Grid>
                    <Grid item xs={2} sx={{ textAlign: "right" }}>
                        {isValid && (
                            <Button
                                variant="contained"
                                onClick={() => {
                                    raiseTask(target)
                                }}
                            >
                                Go
                            </Button>
                        )}
                    </Grid>
                </Grid>
            </Bound>
        </ListItem>
    )

    function stringifyData(d) {
        console.log({ transformIn: d })
        if (workingValue) {
            return workingValue
        }
        try {
            return JSON.stringify(d)
        } catch (e) {
            return d
        }
    }

    function checkValid(d) {
        console.log({ transformOut: d })
        try {
            const data = JSON.parse(d)
            setIsValid(true)
            setWorkingValue(null)
            return data
        } catch (e) {
            setWorkingValue(d)
            setIsValid(false)
        }
        return d
    }

    function isUpdated() {
        return false
    }
}
